import { BookOpen, MapPin, Briefcase, type LucideIcon } from "lucide-react";

export const primaryNavLinks: { href: string; label: string; icon: LucideIcon }[] = [
  { href: "/ebooks", label: "E-BOOKI", icon: BookOpen },
  { href: "/tours", label: "PLANY PODRÓŻY", icon: MapPin },
  { href: "/tours/custom", label: "SPERSONALIZOWANA WYCIECZKA", icon: Briefcase },
];
